import { render } from "./layout-header.vue?vue&type=template&id=60f1a13f&scoped=true&ts=true"
import script from "./layout-header.vue?vue&type=script&lang=ts"
export * from "./layout-header.vue?vue&type=script&lang=ts"

import "./layout-header.vue?vue&type=style&index=0&id=60f1a13f&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f1a13f"]])

export default __exports__